// <-- Ready Function JS START -->
$(document).ready(function(e){
  var  variantopt1 = $('.variant-input-wrapper[data-option-index="option1"] .variant___item input:checked').val();
  var  variantopt3 = $('.variant-input-wrapper[data-option-index="option3"] .variant___item input:checked').val();
  $('.variant-input-wrapper[data-option-slug="total-carat"] .variant___item.gvsDisable').removeClass("gvsDisable");
  $('.variant-input-wrapper[data-option-slug="total-carat"] .variant___item').each(function(){
    var variantopt2 = $(this).find("input").val();
    var thisString = variantopt1+" / "+variantopt2+" / "+variantopt3;
    var thisLength = $("select.gvsMainSelect option[vtitle='"+thisString+"']").length;
    if(thisLength==0){$(this).addClass("gvsDisable");}
  });
  // <-- All Slick Sliders JS - START -->
  $('.announcement-slider').slick({slidesToShow:1, slidesToScroll:1, prevArrow:false, nextArrow:false, autoplay:true, speed:300, swipe:true, fade:true });
  $('.home-inline-items-slider').slick({slidesToShow:5, slidesToScroll:1, infinite:true, swipe:true, arrows:true, responsive: [{breakpoint: 749, settings: {slidesToShow:1, slidesToScroll: 1, infinite:true, swipe:true, arrows:true }}]});
  $('.Inline_items-Image').slick({slidesToShow: 1, slidesToScroll: 1, swipe: false, fade: true, prevArrow:false, nextArrow:false, asNavFor: '.Inline_items-Image_Vertical' });
  $('.Inline_items-Image_Vertical').slick({slidesToShow: 4, slidesToScroll: 1, vertical:true, focusOnSelect: true, asNavFor: '.Inline_items-Image'});
  $('.Inline_items-Image-moBILe').slick({dots:true, slidesToShow: 1, fade: true, infinite: true, prevArrow:false, nextArrow:false, adaptiveHeight: true});
  $('.customVideoInlineItems').slick({responsive:[{breakpoint: 9999, settings: "unslick" },{breakpoint:1100,settings:{slidesToShow:4,slidesToScroll:1,swipe:true,infinite:true}},{breakpoint:999,settings:{slidesToShow:3,slidesToScroll:1,infinite:true,arrows:true,swipe:true}},{breakpoint:749, settings:{slidesToShow:1, slidesToScroll:1, infinite:true, arrows:false, swipe:true, centerMode:true}}]});
  $('.home-collection').slick({slidesToShow:5, slidesToScroll:1, infinite:true, swipe:true, arrows:true, responsive: [
  {breakpoint: 1100, settings: {slidesToShow:4, slidesToScroll: 1, infinite:true, swipe:true, arrows:true, centerMode: true, accessibility: false}},
  {breakpoint: 991, settings: {slidesToShow:3, slidesToScroll: 1, infinite:true, swipe:true, arrows:true, centerMode: true, accessibility: false}},
  {breakpoint: 749, settings: {slidesToShow:1, slidesToScroll: 1, infinite:true, swipe:true, centerMode: true, arrows:false, accessibility: false}}]});
  $('.video_Image').slick({slidesToShow:1, slidesToScroll:1, infinite:true, swipe:true, arrows:true});
  $('.InnerMobileWrapperBx').slick({slidesToShow:1, slidesToScroll:1, infinite:true, swipe:true, arrows:true});
  $('.about_banner.grid').slick({responsive:[{breakpoint: 9999, settings: "unslick"},{breakpoint: 749, settings:{slidesToShow:1, slidesToScroll:1, swipe:true, arrows:true, dots: true}}]});
  $('.testimonials_slider').slick({responsive:[{breakpoint: 9999 , settings: "unslick"},{breakpoint: 768 ,settings:{slidesToShow:1, slidesToScroll:1, arrows: true, swipe: true, infinite: false, dots: true}}]})
  $('.color_rings_box_main').slick({responsive:[{breakpoint: 9999, settings: "unslick"},{breakpoint: 768, settings:{slidesToShow:1,slidesToScroll:1,swipe:true,dots:true,arrows:true}}]})
  $(".pRODuct_Recommendation-ItemsSlide").slick({ responsive:[{ breakpoint:9999, settings:{ slidesToShow: 3, slidesToScroll: 1, infinite: true, arrows: true, swipe: true } },{breakpoint:1101, settings:{ slidesToShow:2,slidesToScroll:1,infinite:true,swipe:true }}, {breakpoint:989, settings:{ slidesToShow:3,slidesToScroll:1,infinite:true,swipe:true } }] });
  if ($(window).width() <= 991){
    $('.homeReviewsItems').slick({responsive:[{breakpoint: 9999,settings: "unslick"},{breakpoint: 991, settings:{ slidesToShow:3, slidesToScroll: 1, infinite:true, swipe:true, arrows:false, centerMode:true }},
      {breakpoint: 749,settings: {slidesToShow:1, slidesToScroll: 1, infinite:true, swipe:true, arrows:false, centerMode: true}}]});
  }
  function slickRefresh(){ $('.announcement-slider').slick('refresh'); $('.home-inline-items-slider').slick('refresh'); $('.home-collection').slick('refresh'); $('.video_Image').slick('refresh'); $('.InnerMobileWrapperBx').slick('refresh'); $('.homeReviewsItems').slick('refresh'); $('.home-collection').slick('setPosition');}
  slickRefresh(); $(window).resize(function(){ slickRefresh(); }); 
  // <-- All Slick Sliders - END -->
  // <-- Footer Accordian MOBILE - START -->
    if ($(window).width() < 750) {
    $(document).on("click",'.footerPopularListItem h3',function(e){
      $(this).parents('.footerRightConterOuter').siblings('.footer-socialMedia-Mobile').children('.footer-socialMedia').removeClass('active').children('.social-logo').removeClass('active').slideUp();
      $(this).parents('.footerPopularListItem').toggleClass('active');$(this).parents('.footerPopularListItem').children('.ftpopularListCnt').slideToggle().parents('.footerMainPopularList').siblings().children('.footerPopularListItem').removeClass('active').children('.ftpopularListCnt').slideUp();
    });
  }
  // <-- Footer Accordian MOBILE - END -->
});
// <-- Ready Function JS END -->
// <-- Cart Drawer JS - START -->
  /*
  $("body").on("change", "select[data_change_chain_length_select]", function() {
    var e = $(this).val();
    "18 Long +$49.99" == e ? ($("input[data_change_chain_length-1]").removeAttr("name"), $("input[data_change_chain_length]").attr("name", "id[]")) : "20 Long +$69.99" == e ? ($("input[data_change_chain_length]").removeAttr("name"), $("input[data_change_chain_length-1]").attr("name", "id[]")) : $("input[data_change_chain_length], input[data_change_chain_length-1]").removeAttr("name")
  });
  */
  $("body").on("change", "select[data_change_chain_length_select]", function() {
    var pID = $(this).find(':selected').data('val')
    if(pID){
      $("#chain-len-id").val(pID);
    }
  });

function gvsaddingItems(thisItem) {
  //debugger;
  $('[js-intializeaddingcart]').children('span').text('Adding...');
  var engrave_custom_text = $(".engrave_custom_text input[name='properties[Engraving]']").val();
  engrave_custom_text = engrave_custom_text ? engrave_custom_text.trim() : '';
  if(($(thisItem).parents('form').find('.luxry_custom_text .luxry:checked').length>0) || ($(thisItem).parents('form').find('input[data_change_chain_length]').val()) || (engrave_custom_text.length>0)){
var PData = [];
    if($(thisItem).parents('form').find('.luxry_custom_text .luxry:checked').length>0){
      PData.push({
        quantity: 1,
        id: $(thisItem).parents('form').find('.luxry_custom_text .luxry').val()
      });
    }

    if($(thisItem).parents('form').find('input[data_change_chain_length]').val()){
    
      PData.push({
        quantity: 1,
        id: $(thisItem).parents('form').find('input[data_change_chain_length]').val()
      });
    }
    


    if(engrave_custom_text.length>0){
      PData.push({
  quantity: 1,
  id: 36402751537315
});
    }    
  //console.log("PData");
//console.log(PData);

const data = {
	items: PData
};
    
  $.ajax({ url:"/cart/add.js", type:"POST", dataType:'JSON', data:data,
            success:function(){$(".gvsHiddenSubmit").trigger("click"); $('[js-intializeaddingcart]').children('span').text('Add To Cart');} 
          });
  }
  else{
    $('[js-intializeaddingcart]').children('span').text('Add To Cart');
      $(".gvsHiddenSubmit").trigger("click");
  }
}



function addingItems(fetched){ var mainProductSerialize = $(fetched).parents('form').serialize();
                            
  $('[js-intializeaddingcart]').children('span').text('Adding...');
  $.ajax({ url:"/cart/add.js", type:"POST", dataType:'JSON', data:mainProductSerialize,
  success:function(){ if( $.trim($('[name="properties[Engraving]"]').val()) == ' ' ){ }
  else { if(($('.hiddenValSlect').val() != "") && ($('.hiddenEngrveSlct').val() != "")){
      var getEngarvingId = $('[EngraveProductForm-JS]').serialize();
      $.ajax({ url:"/cart/add.js", type:"POST", dataType:'JSON', async: false, data:getEngarvingId,
        success:function(){ fetchingCartItems(); }
      }); 
    } else{
        fetchingCartItems(); 
      }
    } if( $('.luxry[type="checkbox"]:checked') ){
        if($('.hiddenLuxarySlct').hasClass('checked')){
          var getLuxaryId = $('[LuxaryProductForm-JS]').serialize();
          $.ajax({ url:"/cart/add.js", type:"POST", dataType:'JSON', data:getLuxaryId,
            success:function(){ fetchingCartItems(); } 
          });
        } else{ fetchingCartItems(); } 
      } else { }
    }, error:function(){ console.log('Error') } 
  });
}

function fetchingCartItems(){ 
  $.ajax({ url:"/cart.js", type:"GET", dataType:"JSON",
    success:function(response){ 
      $('#cart-count').html(response.item_count); $("#pRIMECartDrawer-Form").load(" #pRIMECartDrawer-Form"); $('.pRIMe-Drawer_Main').html($(response).find('.pRIMe-Drawer_Main').html()); $('.pRIMe-Drawer_Outer').addClass('active'); $('body').addClass('active'); 
    } });
}

$(document).on('click', '[js-intializeaddingcart]', function(e){ 
  e.preventDefault();  var obj = $(this);
  if( $('[name="properties[Ring Size]"]').length > 0 ){
    if( $('[data_rings_size] option:selected').val() == 'None'  ){ $('.size_selecter').addClass('ohNoWP'); $('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); }
    else if($('[shape__chage] option:selected').val() == 'None' ){ $('.option_chain_length_Men').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); }
    else if($('[data_change_chain_length_select] option:selected').val() == 'None'){ $('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); }
    else{ //addingItems(this); 
      gvsaddingItems(this); 
    }
  } 
  else{ //addingItems(this); 
      gvsaddingItems(this); 
    }
});

$(document).on('click','.ad_to_cart_coll',function(e){ e.preventDefault();
  if( $('[data_rings_size] option:selected').val() == 'None'  ){ $('.size_selecter').addClass('ohNoWP'); $('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({
    scrollTop: $($('.product__title')).offset().top  }, 500); }
  else if($('[shape__chage] option:selected').val() == 'None' ){ $('.option_chain_length_Men').addClass('ohNoWP');$("html, body").animate({
    scrollTop: $($('.product__title')).offset().top  }, 500); }
  else if($('[data_change_chain_length_select] option:selected').val() == 'None'){$('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({
    scrollTop: $($('.product__title')).offset().top  }, 500); }
  else{ $('.product-form__submit').trigger('click'); }
});

$(document).on('click','.CheckoutButton',function(e){ e.preventDefault();
  if( $('[data_rings_size] option:selected').val() == 'None'  ){ $('.size_selecter').addClass('ohNoWP'); $('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); } 
  else if($('[shape__chage] option:selected').val() == 'None' ){ $('.option_chain_length_Men').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); }
  else if($('[data_change_chain_length_select] option:selected').val() == 'None'){$('.option_chain_length').addClass('ohNoWP'); $("html, body").animate({ scrollTop: $($('.product__title')).offset().top  }, 500); }
  else{$(this).children('span').addClass('hidden').siblings('.loading-overlay__spinner').removeClass('hidden');var FormSerialize = $(this).parents('form').serialize();$.ajax({ url:"/cart/add.js", type:"POST", dataType:'HTML', data:FormSerialize, success:function(response){if( $('.luxry[type="checkbox"]:checked').length > 0 ){var luxuryBox = $('.luxry[type="checkbox"]').val(); $.ajax({ url:"/cart/add.js", type:"POST", dataType:'JSON', data: {id:luxuryBox,quantity:1}, success:function(response){ window.location.href = "/checkout";}})}else{window.location.href = "/checkout";}}});}
});

$(document).on("click",".pRIMe-Drawer-Footer_Checkout-btn", function(e){ e.preventDefault(); window.location.href = "/checkout";});

$(document).on("click",".proDCT_Remove", function(e){ e.preventDefault();var output=$(this).attr('p-id');
  $.ajax({url: '/cart/change.js', type: 'POST', dataType:'JSON', data: {line:output,quantity:0}, success: function(updated){$.ajax({url:"/cart.js", dataType:"JSON", type:"get", success:function(cart){$('#cart-count').html(cart.item_count);$("#pRIMECartDrawer-Form").load(" #pRIMECartDrawer-Form");$('.pRIMe-Drawer_Main').html($(updated).find('.pRIMe-Drawer_Main').html());$('.pRIMe-Drawer_Outer').addClass('active');$('body').addClass('active');}});}});
});

$(document).on("click",".qty_Minus",function(e){ var fieldName = $(e.target).attr('field');var currentVal = parseInt($('input[id='+fieldName+']').val());var parent = $(e.target).closest('div');var currentVariant = parseInt(parent.find('input[id=' + fieldName + ']').attr('variantid'));
  $.ajax({type: 'post', dataType:'JSON', url: '/cart/change.js', data: {line:currentVariant,quantity:currentVal - 1},
  success: function(updated){$.ajax({url:"/cart.js", dataType:"JSON", type:"get", success:function(cart){$('#cart-count').html(cart.item_count);$("#pRIMECartDrawer-Form").load(" #pRIMECartDrawer-Form");}});}});
});

$(document).on("click",".qty_Plus",function(e){ var fieldName = $(e.target).attr('field'); var currentVal = parseInt($('input[id='+fieldName+']').val());var parent = $(e.target).closest('div'); var currentVariant = parseInt(parent.find('input[id=' + fieldName + ']').attr('variantid'));
  $.ajax({type: 'post', url: '/cart/change.js', dataType:'JSON', data: {line:currentVariant,quantity:currentVal + 1},
  success: function(updated){$.ajax({ url:"/cart.js", dataType:"JSON", type:"get", success:function(cart){$('#cart-count').html(cart.item_count); $("#pRIMECartDrawer-Form").load(" #pRIMECartDrawer-Form");}});}})
});

$(document).on('click','.proDCT-baG',function(){ $('.pRIMe-Drawer_Outer').addClass('active'); $('body').addClass('active'); });

$(document).on('click','.pRIMe-Drawer_head-close',function(){ $('[js-intializeaddingcart]').children('span').text('Add To Cart'); $('.pRIMe-Drawer_Outer').removeClass('active'); $('body').removeClass('active'); });

$(document).on("click",'.proDCT-Details',function(){ $(this).next('.proDCT_Dropdown-details').slideToggle(); });

// <-- Cart Drawer JS - END -->

// <-- All Header JS - START -->

function currencyFormSubmit(event) { event.target.form.submit(); }
document.querySelectorAll('.shopify-currency-form select').forEach(function(element) { element.addEventListener('change', currencyFormSubmit); });

$(document).on('click','.header__icon .icon-hamburger',function(e){ e.preventDefault(); $('.menu-drawer-container').addClass('menu_Header'); $('body').addClass('menu_Header'); });

$(document).on('click','.header__icon .icon-close',function(e){ e.preventDefault(); $('.menu-drawer-container').removeClass('menu_Header menu-opening'); $('body').removeClass('menu_Header'); });

if($('.pRIMe_MENU-drawer-LIST > li > summary').next().css('display','none')){
  $(document).on('click','.pRIMe_MENU-drawer-LIST > li > summary',function(){
  $(this).parents('.pRIMe_MENU-drawer-LIST li').children('#pRIMe_dRAWEr-accordian').toggleClass('active').siblings('.pRIMe_MENU-drawer-LIST > li > summary').toggleClass('active');
  $(this).parents('.pRIMe_MENU-drawer-LIST li').children('#pRIMe_dRAWEr-accordian').slideToggle();
  });
}

$('.menu-parent--li').click(function(e){
//  e.preventDefault();
  $('.menu-drawer-container').addClass('menu_Header menu-opening');
  $(this).find('.menu-accordion').show();
});

$('.Currency_Select').click(function(){
   $('.menu-drawer-container').addClass('menu_Header menu-opening');
})
// <-- All Header JS - END -->

// <-- All Footer JS - START -->

if($('.social-logo').css('display','none')){
  $(document).on("click",".follow-accordian",function(){
    $(this).parents('.footer-socialMedia-Mobile').siblings('.footerRightConterOuter').children('.footerMainPopularList').children('.footerPopularListItem').removeClass('active');
    $(this).parents('.footer-socialMedia-Mobile').siblings('.footerRightConterOuter').children('.footerMainPopularList').children('.footerPopularListItem').children('.ftpopularListCnt').slideUp();
    $(this).parents('.footer-socialMedia').toggleClass('active').children('.social-logo').toggleClass('active').slideToggle();	
  });
}

// <-- All Rest Pages JS - START -->

$(document).on('click','.pRIMeCollReadmore',function(e){
  e.preventDefault();
  if($('.pRIMeCollReadmore').text() == 'Read more..'){ 
    setTimeout(function(){
      $('.desshort').hide();
    },70);
    $('.desfull').slideDown();
    $(this).text('Read less'); }
  else{ 
    $('.desshort').show();
    $('.desfull').slideUp();
    $(this).text('Read more..'); 
  } 
}); 

$(document).on('click','.pRIMe_Custom-readmore1',function(e){
  e.preventDefault();
  if($('.pRIMe_Custom-readmore1').text() == 'Read more..'){ 
    $('.toggleRead').slideDown();
    $(this).text('Read less'); 
  }
  else{ 
    $('.toggleRead').slideUp();
    $(this).text('Read more..'); 
  } 
}); 


if($('.most-popular-engagement-ring-types').css('display','none')){ $(document).on('hover','.most-popular-ring, .most-populer-type',function(e){ e.preventDefault(); $('.most-popular-engagement-ring-types').toggleClass('active').toggle(); }); }

$('body').on("click", '.monthly_payments .split_paymnt .learm__more', function(e){
e.preventDefault();
$("div#splitit-container span.-splitit--logo").trigger("click");
});

$('body').on("click", '.monthly_payments .affrim a.learm__more', function(e){
  e.preventDefault();
  $("p#learn-more").trigger("click");
});
// <-- All Rest Pages JS - END -->

// <-- BODY Click JS - START -->

$(document).on('mouseup',function(e){ 
  if ( (!$(e.target).closest('[js-popupgridwrpthmbnpr]').length) && (!$(e.target).closest('.popReviewsWidgetLoox').length) && (!$(e.target).closest('.pRIMe-Drawer_Outer').length) && (!$(e.target).closest('.pRIMe_MENU-drawer').length) ){ $('[js-popupgridwrpthmbnpr]').removeClass('active'); $('body').removeClass('popupEnabledWp'); $('.menu-drawer-container').removeClass('menu_Header menu-opening'); $('body').removeClass('menu_Header');  $('.disclosure__list').css('display','none'); $('.popReviewsWidgetLoox').removeClass('popUpLooxWidget'); $('body').removeClass('reviewPopup'); $('.pRIMe-Drawer_Outer').removeClass('active'); $('body').removeClass('active'); } });

// <-- BODY Click JS - END -->

// <-- Window Load JS START -->

window.addEventListener("load", function(e) {

  if( $('#splitit-container').length > 0 ){
    var t = $("#learn-more").attr("data-amount");
    t /= 100, $("#splitit-container").attr("data-splitit-amount", t), setTimeout((function() {
        affirm && (affirm.ui.refresh(), splitit.ui.refresh())
    }), 400)
  }

  if($('.desshort .collCnt').text() ==''){
    $('.readToggleColl').css('display','none')
  } else{
    $('.readToggleColl').css('display','block')
  }

  var imgID = $('.mainProductGrid').attr('selectedvid');
  $('[imgid="'+imgID+'"]').trigger('click');

  if($('.InnerMobileWrapperBx').children('.slick-list').children('.slick-track').html() != ''){
    $('.pRIMe_Product__ActionItem').css('display','flex');
  }

    var loc = $(location).attr('href')
    console.log('Location: '+loc)
  
});

// <-- Window Load JS END -->

// <-- All Rounder JS - START -->

$(document).on('click','.customLearn',function(){
  e.preventDefault();
  $('p#learn-more').trigger('click');
})
$(document).on('click','.scrollArrowMain',function(){ $("html, body").animate({ scrollTop: $($('#shopify-section-announcement-bar')).offset().top  }, 700); });

$(document).ready(function(){
  var v = $('select[name="options[Total Carat]"]').val();
  var dc = v.split("CT Total ");
  var val = dc[1];
  if(val=="(1.00CT Center)" || val=="(1.25CT Center)" || val=="(1.50CT Center)" || v=="1.00CT Center"  || v=="1.25CT Center"  || v=="1.50CT Center"  || v=="1.00CT Total"  || v=="1.15CT Total"  || v=="1.25CT Total" || v=="1.30CT Total" || v=="1.50CT Total" ){ 
      $('select[name="options[Diamonds Quality]"] option[value="G-H / VS1-VS2 (Our Premium)"]').addClass('hide-option').attr('disabled', true);
  }else{
     $('select[name="options[Diamonds Quality]"] option[value="G-H / VS1-VS2 (Our Premium)"]').removeClass('hide-option').attr('disabled', false);
  }
  ////////////////////////
  var getv = $('select[name="options[Diamonds Quality]"]').val();
  if(getv=="G-H / VS1-VS2 (Our Premium)"){
        $('select[name="options[Total Carat]"] option').each(function(){
           var v = $(this).val();
           var dc = v.split("CT Total ");
           var val = dc[1];
            if(val=="(1.00CT Center)" || val=="(1.25CT Center)" || val=="(1.50CT Center)"  || v=="1.00CT Center"  || v=="1.25CT Center"  || v=="1.50CT Center"  || v=="1.00CT Total"  || v=="1.15CT Total"  || v=="1.25CT Total" || v=="1.30CT Total" || v=="1.50CT Total" ){
              $(this).addClass('hide-option').attr('disabled', true);
            }
        });
  }else{
      $('select[name="options[Total Carat]"] option').removeClass('hide-option').attr('disabled', false);
  }
  ////////////////////
      var url = $('select[name="id"]').val();
      var ty = $('select[name="options[Metal/Color]"]').val();
      var type = ty.split(" "); 
      ////////
      var cuV = $('select[name="id"] option[value='+url+']').data().weight;
      ///////
      if(type[0]=='Platinum'){
         $('span[data_item_metal_color]').text(type[0]);
      }else{
        $('span[data_item_metal_color]').text(type[1]);
      }
      //////
      $('span[data_item_metal_type]').text(type[0]);
      $('span[data_item_weight]').text(cuV);
  
  ///////////////////
  $("body").on("change", 'select[name="options[Total Carat]"]', function() {
      var v = $(this).val();
     // alert(v);
      var dc = v.split("CT Total ");
      var val = dc[1];
      if(val=="(1.00CT Center)" || val=="(1.25CT Center)" || val=="(1.50CT Center)" || v=="1.00CT Center"  || v=="1.25CT Center"  || v=="1.50CT Center"  || v=="1.00CT Total"  || v=="1.15CT Total"  || v=="1.25CT Total" || v=="1.30CT Total" || v=="1.50CT Total" ){ 
          $('select[name="options[Diamonds Quality]"] option[value="G-H / VS1-VS2 (Our Premium)"]').addClass('hide-option').attr('disabled', true);
      }else{
         $('select[name="options[Diamonds Quality]"] option[value="G-H / VS1-VS2 (Our Premium)"]').removeClass('hide-option').attr('disabled', false);
      }
  })
  $("body").on("change", 'select[name="options[Diamonds Quality]"]', function() {
      var getv = $(this).val();
      if(getv=="G-H / VS1-VS2 (Our Premium)"){
            $('select[name="options[Total Carat]"] option').each(function(){
               var v = $(this).val();
               var dc = v.split("CT Total ");
               var val = dc[1];
                if(val=="(1.00CT Center)" || val=="(1.25CT Center)" || val=="(1.50CT Center)"  || v=="1.00CT Center"  || v=="1.25CT Center"  || v=="1.50CT Center"  || v=="1.00CT Total"  || v=="1.15CT Total"  || v=="1.25CT Total" || v=="1.30CT Total" || v=="1.50CT Total" ){
                  $(this).addClass('hide-option').attr('disabled', true);
                }
            });
      }else{
          $('select[name="options[Total Carat]"] option').removeClass('hide-option').attr('disabled', false);
      }
  })
  ///////Weight Color////////
  
  $("body").on("change", 'select[name="options[Metal/Color]"]', function() {
      var url = window.location.search.substring(1);
      var urlSplit =  url.split('=');
      var ty = $(this).val();
      var type = ty.split(" "); 
      ////////
      var cuV = $('select[name="id"] option[value='+urlSplit[1]+']').data().weight;
      ///////
      if(type[0]=='Platinum'){
         $('span[data_item_metal_color]').text(type[0]);
      }else{
        $('span[data_item_metal_color]').text(type[1]);
      }
      //////
      $('span[data_item_metal_type]').text(type[0]);
      $('span[data_item_weight]').text(cuV);
      
      ////// 
      //alert(type[0]);
  });
  $("body").on("change", 'select[name="options[Total Carat]"]', function() { 
    var getval = $(this).val();
    var urlSplit =  getval.split('CT Total (');
    var urlSplit2 =  urlSplit[1].split('CT Center)');
    
    $('span[data_item_diamond_carat]').text(urlSplit[0]+" Carat");
    $('span[data_item_diamond_center]').text(urlSplit2[0]+" Carat");
    //alert(urlSplit2[0]);
  });
  
  

});
  
